import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppConfig } from '../services/app.config';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './login.html',
  styleUrls: ['./login.scss']
})
export class Login {
  username: string = '';
  password: string = '';
  errorMessage: string = '';

  constructor(
    private http: HttpClient,
    private router: Router,
    private appConfig: AppConfig,
    private authService: AuthService
  ) {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/dashboard']);
    }
  }

  // onLogin(): void {
  //   let response = { token: 'mock-token' }; // Mock response for demonstration
  //       if (response.token) {
  //         // this.authService.login(response.token);
  //         this.router.navigate(['/logs']);
  //       }
  // }


  loginWithSSO() {
  window.location.href = environment.apiUrl + 'azure_auth/login';
}
}
